<template>
  <div class="pending-revies">
    <!-- 待举办活动门店 -->
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.myApproval')"></NavHeaderBar>
    <EventFilter
      pageType="incentive"
      :product-options="statusList"
      @filter-change="onFilterChange"
    />
    <div class="review-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="$t('tips.noMoreData')" @load="onLoad" :immediate-check="false">
          <div class="activity-item" v-for="(item, index) in list" :key="index">
            <!-- 门店分配时间： -->
            <div class="header-info">
              <span>{{ $t('shared.filter.time') }}：{{ item.localCreateTime }}</span>
              <span class="status-text" :class="{'status10': item.status === 10, 'status_1': item.status === -1}">{{ item.status === 1 ? $t('shared.pendingReview') : item.status === 10 ? $t('shared.approved') : item.status === -1 ? $t('shared.rejected') : '' }}</span>
            </div>
            <div class="item-body">
              <div class="ba-desc van-ellipsis">{{ item.createUserName }} {{ $t('shared.titleTwentyThree') }}.</div>
              <div class="store-info">
                <img src="@/assets/images/store.png" class="row-icon" />
                <span class="store-name van-ellipsis">{{ item.customerName }}</span>
              </div>
            </div>
            <div class="oper-btn">
              <van-button v-if="item.status === 1" plain type="primary" color="#555555" size="small" @click="toPage(`/pendingRevies/detail?reviewId=${item.id}`)">{{ $t('button.review') }}</van-button>
              <van-button v-else plain type="primary" color="#555555" size="small" @click="toPage(`/pendingRevies/detail?reviewId=${item.id}`)">{{ $t('button.detail') }}</van-button>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { auditAppListPageApi } from '@/api/pendingRevies'
import EventFilter from '@/components/EventFilter'
export default {
  name: 'PendingRevies',
  components: {
    EventFilter
  },
  data () {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      page: 1,
      pageSize: 10,
      statusList: [
        { label: this.$t('shared.pendingReview'), value: 1 }, // 待审核
        { label: this.$t('shared.approved'), value: 10 }, // 已通过
        { label: this.$t('shared.rejected'), value: -1 }
      ],
      statusVal: '',
      startTime: '',
      endTime: ''
    }
  },
  activated () {
    this.page = 1
    // Initial load
    this.onLoad()
  },
  methods: {
    onFilterChange (data) {
      this.statusVal = data.product
      this.startTime = data.startDate
      this.endTime = data.endDate
      this.onRefresh()
    },
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    onLoad () {
      // Mock API call
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const data = {
        page: this.page,
        limit: 10,
        status: this.statusVal,
        startTime: this.startTime,
        endTime: this.endTime
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      auditAppListPageApi(data).then(res => {
        Toast.clear()
        if (this.page === 1) {
          this.list = res.data.list
        } else {
          this.list = [...this.list, ...res.data.list]
        }
        this.loading = false
        this.page++
        if (this.list.length >= Number(res.data.totalRow)) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    toPage (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.pending-revies {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 13px;

  .review-content {
    flex: 1;
    overflow-y: auto;
  }
  .activity-item {
    background-color: #fff;
    margin-bottom: 1px; // Divider effect
    border-bottom: 1px solid #f0f0f0;

    .header-info {
      display: flex;
      justify-content: space-between;
      padding: 12px 10px 10px 10px;
      border-bottom: 1px solid #f0f0f0;
      color: #7f7f7f;
      .status-text {
        color: #0db00b;
      }
      .status10 {
        color: #307bff;
      }
      .status_1 {
        color: #c4200b
      }
    }

    .item-body {
      padding: 10px;
      color: #555;
      .ba-desc {
        color: #333;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .store-info {
        display: flex;
        align-items: center;
        margin: 5px 0;
        .store-name {
          flex: 1;
          font-size: 13px;
          color: #333;
        }
      }

      .row-icon {
        width: 13px;
        height: 13px;
        margin-right: 6px;
        object-fit: contain;
      }
    }
    .oper-btn {
      display: flex;
      justify-content: flex-end;
      padding: 10px;
      padding-top: 0;
      /deep/.van-button {
        height: 30px;
        border-radius: 5px;
        margin-left: 10px;
      }
    }
  }
}
</style>
